export const COLOR_INVALID = "#b32424";
export const BORDER_RADIUS = ".3rem";
